import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinLokasiTugas = createAsyncThunk(
    "lokasiTugas/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMinMasterLokasiTugas',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getMinLokasiTugasSelector = createAsyncThunk(
    "lokasiTugas/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMinMasterLokasiTugas',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.LokasiTugasID,
                        label: item.NamaLokasiTugas,
                        CategoryID: "3",
                    })
                );
                return {data: newObj};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)


export const getLokasiTugas = createAsyncThunk(
    "lokasiTugas/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMasterLokasiTugas',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertLokasiTugas = createAsyncThunk(
    "lokasiTugas/insert",
    async ({namaLokasiTugas, lokasiTugasID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("namaLokasiTugas", namaLokasiTugas);
        formData.append("lokasiTugasID", lokasiTugasID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertMasterLokasiTugas',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateLokasiTugas = createAsyncThunk(
    "lokasiTugas/update",
    async ({namaLokasiTugas, idLokasiTugas, status}, thunkAPI) => {
        let formData = new FormData();
        formData.append("namaLokasiTugas", namaLokasiTugas);
        formData.append("lokasiTugasID", idLokasiTugas);
        formData.append("status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateMasterLokasiTugas',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const lokasiTugasSlice = createSlice({
    name: "lokasiTugas",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinLokasiTugas.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinLokasiTugas.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinLokasiTugas.pending]: (state) => {
            state.isMinFetching = true;
        },
        [getMinLokasiTugasSelector.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinLokasiTugasSelector.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinLokasiTugasSelector.pending]: (state) => {
            state.isMinFetching = true;
        },


        [getLokasiTugas.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getLokasiTugas.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getLokasiTugas.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertLokasiTugas.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertLokasiTugas.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertLokasiTugas.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateLokasiTugas.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateLokasiTugas.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateLokasiTugas.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const lokasiTugasSelector = (state) => state.lokasiTugas;
